import { makeActionCreator } from '../../config/store/utils'
import { getAgilePurchaseProviders } from '../../services/agilePurchase'

export const GET_AGILE_PURCHASE_PROVIDERS = 'GET_AGILE_PURCHASE_PROVIDERS'
export const GET_AGILE_PURCHASE_PROVIDERS_SUCCESS = 'GET_AGILE_PURCHASE_PROVIDERS_SUCCESS'
export const GET_AGILE_PURCHASE_PROVIDERS_ERROR = 'GET_AGILE_PURCHASE_PROVIDERS_ERROR'

export const onGetAgilePurchaseProviders = makeActionCreator(GET_AGILE_PURCHASE_PROVIDERS)
export const onGetAgilePurchaseProvidersSuccess = makeActionCreator(GET_AGILE_PURCHASE_PROVIDERS_SUCCESS, 'payload')
export const onGetAgilePurchaseProvidersError = makeActionCreator(GET_AGILE_PURCHASE_PROVIDERS_ERROR, 'payload')

export const onGetAgilePurchaseProvidersThunk =
  ({ year, region }) =>
  async dispatch => {
    dispatch(onGetAgilePurchaseProviders())

    try {
      const response = await getAgilePurchaseProviders({ year, region })

      if (response.status !== 200) {
        return dispatch(onGetAgilePurchaseProvidersError(response.data.errores))
      }
      const formattedData = response.data?.payload
        .map(item => ({
          year: item.anio,
          provider: item.proveedor,
          rut: item.rut,
          quantityOC: item.cantidad,
          amount: item.monto,
          amountUSD: item.montoUSD,
          totalQuotations: item.totalContizaciones,
          region: item.region,
          regionId: item.idRegion
        }))
        .sort((a, b) => b.amount - a.amount)
      const csv = [
        [
          'Año',
          'Región',
          'Nombre proveedor',
          'RUT proveedor',
          'Cotizaciones enviadas',
          'Monto (CLP)',
          'Monto (USD)',
          'N° de Ordenes de Compra'
        ],
        ...formattedData.map(item => [
          item.year,
          item.region,
          item.provider,
          item.rut,
          item.totalQuotations,
          item.amount,
          item.amountUSD,
          item.quantityOC
        ])
      ]
      dispatch(onGetAgilePurchaseProvidersSuccess({ data: formattedData, csv }))
    } catch (error) {
      dispatch(
        onGetAgilePurchaseProvidersError({ error: error.message || 'Error al obtener datos de proveedores', data: [] })
      )
    }
  }
